import { Paper, Grid, Typography, TextField } from '@mui/material';
import { useState } from 'react';

export const AppsPermissions = ({ setFieldValue, values, apps }) => {
  const [errors, setErrors] = useState({});

  const handleInputChange = (appId, value) => {
    const fieldName = `apps.app_${appId}`;
    setFieldValue(fieldName, value);

    try {
      if (value?.length) {
        JSON.parse(value);
      }
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
    } catch (error) {
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: 'Invalid JSON' }));
    }
  };

  return (
    <Paper elevation={0} sx={{ padding: 4, maxWidth: '1300px', margin: '30px' }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="body1" fontWeight="bold">
            Apps
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1" fontWeight="bold">
            JSON
          </Typography>
        </Grid>
      </Grid>

      {apps.map((app) => (
        <Grid container alignItems="center" spacing={1} sx={{ marginTop: '10px' }} key={app.id}>
          <Grid item xs={3}>
            <Typography variant="body2">{app.name}</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              multiline
              rows={4}
              label="Enter JSON"
              value={values.apps[`app_${app.id}`]}
              onChange={(e) => handleInputChange(app.id, e.target.value)}
              fullWidth
              error={Boolean(errors[`apps.app_${app.id}`])}
              helperText={errors[`apps.app_${app.id}`] || ''}
            />
          </Grid>
        </Grid>
      ))}
    </Paper>
  );
};
